const ErrorMessage = ({ name, error }: { name: string; error: any }) => {
  const changeName = name?.charAt(0).toUpperCase() + name?.slice(1).replace(/_/g, ' ');
  if (error?.[name]) {
    return (
      <small style={{ color: 'red', fontSize: '11px', position: 'absolute', left: 0, bottom: -15 }}>
        {error?.[name]?.type === 'validate' && error[name]?.message}

        {error?.[name]?.type === 'required' && error?.[name]?.message}
        
        {error?.[name]?.type === 'pattern' && error?.[name]?.message}

        {error?.[name]?.type === 'minLength' && `Пароль должен содержать не менее 8 символов.`}

        {error?.[name]?.type === 'maxLength' &&
          `${changeName} должно содержать не менее 5000 символов.`}
      </small>
    );
  }
  return null;
};

export default ErrorMessage;
